export function split(s) {
  if (!s || s === '') {
    return [];
  }
  return s.split(',').map((s) => s.trim());
}